export const DEFAULT_HELP_URL = 'https://help.jusfy.com.br/';

export function normalizePathname(pathname?: string): string {
  if (!pathname) return '/';

  const sanitizedPathname = pathname.trim();

  if (!sanitizedPathname || sanitizedPathname === '/') return '/';

  const normalizedPathname = sanitizedPathname.startsWith('/')
    ? sanitizedPathname
    : `/${sanitizedPathname}`;

  return normalizedPathname.replace(/\/+$/, '') || '/';
}

export function normalizeUrl(url?: string): string | undefined {
  if (!url) return undefined;

  try {
    const baseUrl =
      typeof window !== 'undefined' && window.location?.origin
        ? window.location.origin
        : DEFAULT_HELP_URL;
    const parsedUrl = new URL(url, baseUrl);

    parsedUrl.hash = '';

    return parsedUrl.toString();
  } catch (error) {
    return url.trim() || undefined;
  }
}

export function getYouTubeVideoId(url?: string): string | null {
  if (!url) return null;

  try {
    const parsedUrl = new URL(url);
    const host = parsedUrl.hostname.replace(/^www\./, '');

    if (host === 'youtu.be') {
      return parsedUrl.pathname.slice(1) || null;
    }

    if (host === 'youtube.com' || host.endsWith('.youtube.com')) {
      if (parsedUrl.pathname === '/watch') {
        return parsedUrl.searchParams.get('v');
      }

      const pathMatch = parsedUrl.pathname.match(/^\/(embed|shorts)\/([^/?]+)/);

      return pathMatch?.[2] || null;
    }
  } catch (error) {
    return null;
  }

  return null;
}

export function getYouTubeEmbedUrl(url?: string): string | null {
  const videoId = getYouTubeVideoId(url);

  return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
}
